import { render, staticRenderFns } from "./_billingAlert.vue?vue&type=template&id=7a22d227&scoped=true&lang=pug&"
import script from "./_billingAlert.vue?vue&type=script&lang=js&"
export * from "./_billingAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a22d227",
  null
  
)

export default component.exports